import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { INumberSlice } from "@/redux/slices/numbers/types";

export const getInclusiveRemaining = createAsyncThunk(
  "numbers/getInclusiveRemaining",
  async () =>
    await axios({
      method: "GET",
      url: `/svc/number-search/get-inclusive-remaining`,
    }).then((res) => res.data)
);

const fulfilled = (
  state: INumberSlice,
  { payload }: { payload: INumberSlice["inclusive"] },
) => {
  state.inclusive = payload;
};

export default {
  action: getInclusiveRemaining,
  fulfilled,
};
